<template>
  <button
    :class="[bgColor]"
    :disabled="isDisabled"
    class="btn flex items-center justify-center text-center rounded font-bold"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script>
import { computed, defineComponent, toRefs } from '@vue/composition-api'

export default defineComponent({
  name: 'KaiButton',
  emits: ['click'],
  props: {
    type: {
      type: String,
      required: false,
      default: 'primary'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { type, isDisabled } = toRefs(props)

    const bgColor = computed(() => {
      switch (type.value) {
        case 'secondary':
          if (isDisabled.value) {
            return 'bg-white-dark text-gray-dark cursor-not-allowed'
          }
          return 'bg-white text-blue-default border hover:shadow-lg'
        default:
          if (isDisabled.value) {
            return 'bg-gray-dark text-white cursor-not-allowed'
          }
          return 'bg-blue-default text-white hover:shadow-lg'
      }
    })

    return {
      bgColor
    }
  }
})
</script>

<style scoped></style>
